import { z } from 'zod'
import { ServiceStatus } from '~/enums/service-status'
import { createServiceIssueRequestSchema } from './create-service-issue-request'

/**
 * 問題答覆 - 更新 Request Schema
 */
export const updateServiceIssueRequestSchema = createServiceIssueRequestSchema
  .partial()
  .merge(
    z.object({
      /** 提問層級 */
      serviceUrgent: z.string().nullable().optional(),
      /** 狀態 */
      serviceStatus: z.nativeEnum(ServiceStatus).optional()
    })
  )

/**
 * 問題答覆 - Request
 */
export interface UpdateServiceIssueRequest
  extends z.infer<typeof updateServiceIssueRequestSchema> {}
